import SelectableButton from '@/common/components/selectable-button/selectable-button.presentational.vue';
import { getPathBySearchObj, getSearchObjByPath } from '../../../../widget/spec/searchHelper.js';
import { mapGetters } from 'vuex';

const tplRegex = new RegExp(/\{\{(.*)\}\}/);

export default {
    name: 'filterShortcuts',
    props: {
        filters: {
            type: Array,
            required: true,
        },
        geo: {
            type: Object,
            required: true,
        },
        filter: {
            type: Object,
            required: true,
        },
    },
    inject: ['$eventBus'],
    components: {
        SelectableButton,
    },
    data() {
        return {
            selectedFilter: null
        }
    },
    computed: {
        ...mapGetters('glb', ['glb'])
    },
    methods: {
        isSelected(item) {
            return item && this.$route.path.includes(item.filterAnnotation.replace('att-',''));
        },
        resetItemFilter(itemFilter) {
            let resetItemFilter = {};
            Object.keys(itemFilter).map(seg => {
                if(itemFilter[seg] && itemFilter[seg].length){
                    resetItemFilter[seg] = this.filter[seg].filter((v) => v !== itemFilter[seg][0])
                } else {
                    if(['minHoa', 'maxHoa'].includes(seg)) {
                        resetItemFilter[seg] = -1;
                    } else {
                        resetItemFilter[seg] = 0
                    }
                }
            });
            return resetItemFilter;
        },
        buildRoute(filter) {
            const isSelected = this.isSelected(filter);
            this.selectedFilter = this.selectedFilter || (isSelected ? filter.filterTitle : null);
            let itemFilter = getSearchObjByPath(filter.mspUrl).filter;
            Object.keys(itemFilter).map(item => {
                if(['ojoAttribute','propertyType'].includes(item) && !isSelected) {
                    itemFilter[item] = [...this.filter[item], ...itemFilter[item]];
                }
            })
            const path = getPathBySearchObj(this.geo, {
                ...this.filter,
                ...(isSelected ? this.resetItemFilter(itemFilter) : itemFilter)
            }, true);
            //change to absolute path
            const fullPath = `${this.glb.appUrl}${path}`.replace('/homes-for-sale/', '/');
            return fullPath;
        },
        filterClicked(filter) {
            this.$eventBus.$emit('ga', { en: 'click', ec: 'shortcut', el: filter.filterTitle });
        },
    },
};
